import { render, staticRenderFns } from "./transceiverSuggest.vue?vue&type=template&id=26d60da6&"
import script from "./transceiverSuggest.vue?vue&type=script&lang=ts&"
export * from "./transceiverSuggest.vue?vue&type=script&lang=ts&"
import style0 from "./transceiverSuggest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports